// Default letter print-layout values (millimetres) for the change-of-address letter.
//
// These position the recipient delivery address inside Whistl's "Engage" Address Zone
// window (80mm x 48mm, 20mm from the left, 40mm from the top -> the 40-88mm vertical band)
// so the address — and only the address — shows through the envelope window.
//
// Calibrated against the issue #59 reference PDFs: at these values the company-name line
// renders ~47mm from the top and the date falls ~98mm (below the 88mm window), staying
// compliant across browser print margins of 0-10mm.
//
// NOTE: keep in sync with the backend schema defaults in
// backend/models/letterSettings.js (the two apps can't share a module).
export const LETTER_PRINT_DEFAULTS = {
  addressTopMm: 25, // .l-address-row margin-top (vertical position of the address block)
  addressDateGapMm: 25, // .l-date-details margin-top (gap between address and date)
  leftOffsetMm: 25, // <page> padding-left (horizontal position -> 20mm window left edge)
};

// Sensible editing bounds for the settings UI (mm).
export const LETTER_PRINT_BOUNDS = {
  addressTopMm: { min: 0, max: 80 },
  addressDateGapMm: { min: 0, max: 80 },
  leftOffsetMm: { min: 0, max: 60 },
};

// Merge saved (partial) settings over the defaults, ignoring null/undefined/non-finite values.
export const resolveLetterPrintSettings = (saved) => {
  const out = { ...LETTER_PRINT_DEFAULTS };
  if (saved && typeof saved === "object") {
    for (const k of Object.keys(LETTER_PRINT_DEFAULTS)) {
      const v = saved[k];
      if (typeof v === "number" && Number.isFinite(v)) out[k] = v;
    }
  }
  return out;
};
